import { map } from 'ramda';

const getSubtotal = (products = []) => products
  .reduce((subtotal, { price }) => subtotal + price, 0);

export const calculateOrderInvoice = (order) => {
  const {
    _id: orderId,
    invoices = [],
    payment:{
      stripe: {
        paymentIntent : {
          id: paymentIntentId,
        } = {},
      } = {},
    } = {
      stripe: {
        paymentIntent: {},
      },
    },
    promo : { code } = {},
  } = order;
  const invoice = [...invoices].pop() || {};
  const {
    _id: invoiceId,
    amount: invoiceTotal,
    products = [],
  } = invoice;
  const subtotal = getSubtotal(products);
  const discount = invoiceTotal - subtotal;
  const totals = [
    { name: 'Subtotal', total: subtotal },
    { name: `Promocode${code ? ` - ${code}` : ''}`, total: discount },
    { name: 'Total', total: invoice.amount },
  ];
  return {
    orderId,
    invoiceId,
    paymentIntentId,
    invoiceTotal,
    subtotal,
    discount,
    totals,
    products,
    promoCode : code,
    hasInvoice: invoiceId !== undefined,
  };
};

export const calculateOrdersInvoice = map(calculateOrderInvoice);
